import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

import { Select } from '@components/shared/form-elements/select/Select';
import { Icon } from '@components/shared/icon/Icon';
import { filterStringToJson } from '../FiltersBar/utils';

import classes from './TopBar.module.scss';

const messages = {
  name_asc: 'Назвою товарів (А – Я)',
  name_desc: 'Назвою товарів (Я – А)',
  price_asc: 'Від дешевих до дорогих',
  price_desc: 'Від дорогих до дешевих',
  popularity: 'За популярністю'
};

export const selectOptions: Array<keyof typeof messages> = [
  'popularity',
  'name_asc',
  'name_desc',
  'price_asc',
  'price_desc'
  // 'height_asc',
  // 'height_desc'
];

export const selectOptionsArray = selectOptions.map((key) => ({
  value: key,
  label: messages[key]
}));

interface IPickerProps {
  setFilter: (value: string) => void;
}

export const SortingSelect: FC<IPickerProps> = ({ setFilter }) => {
  const searchParams = useSearchParams();
  const [sortingKeyState, setSortingKeyState] = useState<string>(selectOptions[0]);

  useEffect(() => {
    const filterPrams = filterStringToJson(decodeURIComponent(searchParams.toString()), undefined);
    if (filterPrams.sortBy) {
      setSortingKeyState([filterPrams.sortBy, filterPrams.sortOrder].filter(Boolean).join('_'));
    }
  }, [searchParams]);

  const onClickHandlerSelect = (event: string | ChangeEvent<Element>) => {
    if (typeof event !== 'string' && 'value' in event.target) {
      const { value } = event.target;
      setFilter(String(value));

      setSortingKeyState(String(value));
    }
  };

  return (
    <div className={classes.wrapperSortingSelect}>
      <Select
        fullWidth
        dropdownMenu
        className={classes.sortingSelect}
        labelIcon={<Icon type="sort" size={24} offset={8} />}
        disableWrapper
        value={sortingKeyState}
        options={selectOptionsArray}
        onChange={onClickHandlerSelect}
        name="sort"
        ariaLabel="Сортування"
      />
    </div>
  );
};
